import MainComponent from "components/Main";
import PropTypes from "prop-types";

import './index.less';
import './themes/default.less';
import Avatar from "components/Avatar";


/**
 * Created by viclight on 04.03.2024.
 */
export class HeaderEmployee extends MainComponent {


    static propTypes = {
        info: PropTypes.object,
    };

    static defaultProps = {
        info: false,
    };

    renderChangePassword() {
        return (
            <div
                className="selectPersone hand"
                onClick={this.props.openDialog.bind(this, "changePassword", null, this.props.changePasswordCB.bind(this))}
            >
                {this.tr("employee.changePassword")}
            </div>
        );
    }

    renderRecoveryPassword() {
        return (
            <div
                className="selectPersone hand"
                onClick={this.props.openDialog.bind(this, "recoveryPassword", null, this.props.recoveryPasswordCB.bind(this))}
            >
                {this.tr("employee.recoveryPassword")}
            </div>
        );
    }

    renderRow(title, component) {
        return (
            <div className="detailRow flex centerV gap24">
                <div className="rowTitle">{this.tr(title)}</div>
                <div className="flex1">{component}</div>
            </div>
        );
    }

    render() {
        const { info } = this.props;
        const { photoUid, birthday, phoneNumber, sex, login, shortName, roleId, status, hireDate } = info;

        const fullName = this._helper.string.formatFullName(info);

        let bdLabel = "";
        let ageLabel = "";
        if (birthday) {
            bdLabel = this._helper.date.toStr(birthday, "DD MMMM YYYY");
            ageLabel = this._helper.date.getAgeStr(birthday);
        }

        const role_sys = this._helper.getRoleLabel(roleId);
        const _status = this._helper.getEmploeeStatusLabel(status);
        const _date_start = this._helper.date.toStr(hireDate, "DD MMMM YYYY");


        return (
            <div className="headerEmployee flex gap24">
                <Avatar
                    id={photoUid}
                    sex={sex}
                    size={120}
                    radius={8}
                    iconWidth={77}
                    iconHeight={103}
                />
                <div className="headerContent flex col flex1 gap24">
                    <div className="firstRow flex between centerV">
                        <div className="text pageTitle">{fullName}</div>
                    </div>
                    <div className="details flex between text p1">
                        <div className="detailsRows flex col gap8">
                            {this.renderRow("employee.dateBirth", (
                                birthday ? (<div>{bdLabel} <span>{ageLabel} </span></div>) : (this.tr("main.notIndicated"))
                            ))}
                            {this.renderRow("employee.fio_short", (
                                (<div>{shortName} </div>)
                            ))}
                            {this.renderRow("employee.tel", <div>{this._helper.string.fromatPhone(phoneNumber)} </div>)}

                        </div>
                        <div className="detailsRows flex col gap8">
                            {this.renderRow("employee.login", (<div>{login}</div>))}
                            {/*this.renderRow("employee.password", (<div className={"flex gap8"}>{this.renderChangePassword()}</div>))*/}
                            {this.renderRow("employee.role_system", (<div>{role_sys}</div>))}
                            {this.renderRow("employee.status", (<div>{_status}</div>))}
                            {this.renderRow("employee.date_start", (<div>{_date_start}</div>))}
                        </div>

                        <div className="detailsRows flex col gap8 dblanc">

                        </div>

                    </div>
                </div>
            </div>
        );
    }

}
